<template>
  <span>
    Credit Note
    <router-link
      tag="a"
      :to="`/credit-notes/view/${eventLog.creditNoteId}`"
      >#{{ eventLog.creditNoteNumber }}</router-link
    >&nbsp;issued to
    <router-link
      tag="a"
      :to="`/customers/view/${eventLog.customerId}`"
      >{{ eventLog.customerName }}</router-link
    >&nbsp;for Invoice
    <router-link tag="a" :to="`/invoices/view/${eventLog.invoiceId}`"
      >#{{ eventLog.invoiceNumber }}</router-link
    >&nbsp;with a total of
    <strong>{{ eventLog.total }}</strong>
  </span>
</template>
<script>
export default {
  name: 'recentActivityTableDescriptionCreditNoteIssued',
  props: {
    eventLog: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
